import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthProvider';

import { LANDING_ROUTES, PRIVATE_ROUTES } from '@/config/routes';
import { getRecord } from '@/utils/storageUtils';

import { selectIsJustSignedUp, selectIsSignInSuccess } from '@/store/profile/profile.selectors';

import { sync } from './synchronizer';

export const useSignInRedirect = () => {
  const { requestAuth } = useAuth();

  const history = useHistory();
  const justSignedUp = useRef(false);
  const isSignedInSuccess = useSelector(selectIsSignInSuccess);

  justSignedUp.current = useSelector(selectIsJustSignedUp);

  useEffect(
    () =>
      requestAuth(() => {
        history.replace(
          justSignedUp.current
            ? LANDING_ROUTES.persona
            : getRecord('redirectedFromPrivate') ?? PRIVATE_ROUTES.home,
        );
      }, 'after'),
    [requestAuth, history],
  );

  useEffect(() => {
    if (isSignedInSuccess) {
      sync('login', {});
    }
  }, [isSignedInSuccess]);
};
